export const IS_PRODUCTION = process.env.NEXT_PUBLIC_ENV === 'production';
export const MEDIA_URL = process.env.NEXT_PUBLIC_MEDIA_URL;
export const IS_PRODUCTION_BUILD =
    process.env.NEXT_PUBLIC_BUILD_NAME === 'production' || process.env.NEXT_PUBLIC_BUILD_NAME?.toString() === 'production';
